module.exports = __webpack_public_path__ + "img/map_7.18135814.png";